export default {"src":"/_next/static/media/hero-bug-left.c1d860d6.gif","height":400,"width":400};